export default __webpack_public_path__ + "static/media/biofit-builder-home-chairs.3ec7a81e.png";